import React, { useEffect, useState } from 'react';
import { isBrowser, isMobile } from "react-device-detect";
import { useHistory } from "react-router";
import Button from 'react-bootstrap/Button';

const Navigation = ({ beforeUrl = null, continueUrl = null }) => {
    const [flexStyle, setFlexStyle] = useState('space-between');
    const history = useHistory();

    useEffect(() => {
        if (beforeUrl == null) {
            setFlexStyle('flex-end');
        } else if (continueUrl == null) {
            setFlexStyle('');
        }
    }, []);

    const onBefore = () => {
        history.push({
            pathname: beforeUrl,
            state: {}
        });
    }

    const onContinue = () => {
        history.push({
            pathname: continueUrl,
            state: {}
        });
    }

    return (
        <div className={`display-flex ${flexStyle}`}>
            { 
                beforeUrl &&
                <Button size="medium" type="button" onClick={onBefore}> <b> Anterior </b> </Button>
            }
            { 
                continueUrl &&
                <Button size="medium" type="button" onClick={onContinue}> <b> Continuar </b> </Button>
            }
        </div>  
    )
}

export default Navigation;